import React from "react"
import { css } from "@emotion/react"
import Modal from "@myvp/shared/src/components/deprecated-modal"
import { useIntl } from "react-intl"
import Button from "@myvp/shared/src/components/buttons/button"
import breakpoints from "@myvp/shared/src/styles/breakpoints"
import useStorageState from "@myvp/shared/src/hooks/use-storage-state"
import { isAndroid } from "@myvp/shared/src/functions/is-android"
import { isIos } from "@myvp/shared/src/functions/is-ios"
import { useLocation } from "react-router"
import { logger } from "@myvp/shared/src/beacons/beacons.model"
import { Semibold28 } from "@myvp/shared/src/typography"
import logoImg from "src/images/logo.png"
import Link from "@myvp/shared/src/components/buttons/link"
import { DO_NOT_TRANSLATE_CONSTANTS } from "@myvp/shared/src/constants"

const SmartBanner = () => {
  const location = useLocation()
  const { pathname } = location
  const state = location.state as { userId?: string } | undefined
  const android = isAndroid()
  const ios = isIos()
  const { formatMessage } = useIntl()
  const [visible, setVisible] = useStorageState(true, "smart-banner")
  if (!android && !ios) {
    return null
  }
  return (
    <Modal
      close={() => {
        logger("ACTIVITY_SMART_BANNER_DISMISS", {
          page: pathname,
          userid: state?.userId,
          platform: ios ? "ios" : "android",
        })
        setVisible(false)
      }}
      clearOnClickOutside={true}
      aria-labelledby="smart-banner-title"
      visible={visible}
      css={css`
        #modal-popup {
          width: 100%;
          max-width: 392px;
          padding: 36px;
          padding-left: 32px;
          padding-right: 32px;
        }
        ${breakpoints("sm")} {
          align-items: flex-end;
          margin: 0;
          #modal-popup {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
          }
        }
        img {
          width: 66px;
          height: 66px;
        }
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          a {
            width: 100%;
          }
          button {
            width: 100%;
            max-width: 318px !important;
          }
        `}
      >
        <img
          alt={DO_NOT_TRANSLATE_CONSTANTS.myveevaforpatients}
          src={logoImg}
        />
        <Semibold28
          id="smart-banner-title"
          css={(theme) => css`
            max-width: 321px;
            width: 100%;
            color: ${theme.palette.content.neutral.subtle};
            text-align: center;
            margin: 22px;
          `}
        >
          {formatMessage(
            { id: "smartBanner.downloadTheMyVeevaApp" },
            { myveeva: DO_NOT_TRANSLATE_CONSTANTS.myveevaforpatients }
          )}
        </Semibold28>
        <Button
          internalType="link"
          variant="primary"
          height="large"
          type="button"
          to={
            ios
              ? (process.env.REACT_APP_ios_app_url as string)
              : (process.env.REACT_APP_android_app_url as string)
          }
          onClick={() => {
            logger("ACTIVITY_SMART_BANNER_VIEW_APPSTORE", {
              page: pathname,
              userid: state?.userId,
              platform: ios ? "ios" : "android",
            })
          }}
          css={css`
            // Mobile autofocuses this on load, but we don't want the outline to show.
            // Since this only appears on mobile devices it's fine to turn off all outlines.
            outline: none;
          `}
        >
          {formatMessage({ id: "smartBanner.getTheApp" })}
        </Button>
        <Link
          internalType="button"
          onClick={() => {
            logger("ACTIVITY_SMART_BANNER_DISMISS", {
              page: pathname,
              userid: state?.userId,
              platform: ios ? "ios" : "android",
            })
            setVisible(false)
          }}
          css={css`
            margin-block-start: 16px;
          `}
        >
          {formatMessage({ id: "smartBanner.continueInBrowser" })}
        </Link>
      </div>
    </Modal>
  )
}

export default SmartBanner
